<template>
  <div id="notifications" class="notifications-wrap">
    <div class="notifications-danger">
      <div v-if="notifications.danger" class="alert alert-danger alert-dismissible">
        {{ notifications.danger }}
        <button type="button" class="close" @click.prevent="closeDanger">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="notifications-warning">
      <div v-if="notifications.warning" class="alert alert-warning alert-dismissible">
        {{ notifications.warning }}
        <button type="button" class="close" @click.prevent="closeWarning">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="notifications-success">
      <div v-if="notifications.success" class="alert alert-success alert-dismissible">
        {{ notifications.success }}
        <button type="button" class="close" @click.prevent="closeSuccess">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'Notifications',

  data() {
    return {
      notifications: {
        danger: '',
        warning: '',
        success: '',
      },
    };
  },

  mounted() {
    this.$store.watch(state => state.notifications.success, (newVal) => {
      this.notifications.success = newVal;
      if (newVal) this.clearSuccess();
    }, { deep: true });
    this.$store.watch(state => state.notifications.warning, (newVal) => {
      this.notifications.warning = newVal;
      if (newVal) this.clearWarning();
    }, { deep: true });
    this.$store.watch(state => state.notifications.danger, (newVal) => {
      this.notifications.danger = newVal;
      if (newVal) this.clearDanger();
    }, { deep: true });
  },

  methods: {
    // Close immediately
    closeDanger() {
      this.$store.commit('notifications/setDangerNotification', '');
    },
    closeWarning() {
      this.$store.commit('notifications/setWarningNotification', '');
    },
    closeSuccess() {
      this.$store.commit('notifications/setSuccessNotification', '');
    },
    // Clear on timeoute
    clearDanger: _.debounce(function () {
      this.$store.commit('notifications/setDangerNotification', '');
    }, 7000),
    clearWarning: _.debounce(function () {
      this.$store.commit('notifications/setWarningNotification', '');
    }, 7000),
    clearSuccess: _.debounce(function () {
      this.$store.commit('notifications/setSuccessNotification', '');
    }, 7000),
  },
};
</script>



// WEBPACK FOOTER //
// Notifications.vue?7faeeb86